import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { initSentry } from './sentry'
import './shared/styles/chat.css'
import './shared/styles/design-tokens.css'

console.info(`[sapiendo] build ${__BUILD_COMMIT__} (${__BUILD_TIMESTAMP__})`)

const app = createApp(App)
initSentry(app, router)
app.use(router)
app.mount('#app')
